import { useOnboarding } from "./useOnboarding";
import { getFlowConfig } from "@/data/flows";
import { FlowConfig } from "@/data/flows/types";

export const useFlowConfig = (): FlowConfig | undefined => {
  const { currentOnboardingFlow } = useOnboarding();
  return getFlowConfig(currentOnboardingFlow);
};
